// extracted by mini-css-extract-plugin
module.exports = {"centerContent":"Auth_centerContent__8_hPh"};